import { QueryClient, QueryKey, UseQueryOptions } from '@tanstack/react-query';

import { getIdTokenPayload } from '$shared/auth/auth-service';
import { FeatureToggle } from '$shared/feature-toggle/types';

import { useGetFeatureToggle } from '$components/app-config/app-config.api';

const checkIsFeatureEnabled = (feature: FeatureToggle, featureList?: string[]) =>
  featureList?.includes(feature) ?? false;

export const isFeatureEnabled = (feature: FeatureToggle) => {
  const { data: featureList } = useGetFeatureToggle();

  return checkIsFeatureEnabled(feature, featureList);
};

export const isFeatureEnabledSync = async <T>(
  queryClient: QueryClient,
  featureToggle: FeatureToggle,
  query: UseQueryOptions<T>,
  queryKey: QueryKey,
) => {
  await queryClient.prefetchQuery(query);

  const cache = queryClient.getQueryCache().find<string[]>({ queryKey });

  return checkIsFeatureEnabled(featureToggle, cache?.state.data);
};

// Check if the user is a support user based on the profile in the idToken payload
// Needs to be removed after the delete feature is implemented for customers.
export const isSupportUser = async () => {
  const claims = await getIdTokenPayload();
  return claims.profile === 'SupportUser';
};
